(() => {
  const elementName = 'gh-featured-video-control';

  if (customElements.get(elementName)) return;

  class GhFeaturedVideoControl extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-gh-video-toggle]');
      this.video = this.closest('.video--root')?.querySelector('.video--container video');

      if (!this.button || !this.video) {
        this.hidden = true;
        return;
      }

      this.userPaused = false;
      this.handleClick = this.handleClick.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.handlePause = this.handlePause.bind(this);

      this.button.addEventListener('click', this.handleClick);
      this.video.addEventListener('play', this.handlePlay);
      this.video.addEventListener('pause', this.handlePause);
      this.video.addEventListener('ended', this.handlePause);
      this.syncState();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      this.video?.removeEventListener('play', this.handlePlay);
      this.video?.removeEventListener('pause', this.handlePause);
      this.video?.removeEventListener('ended', this.handlePause);
    }

    handleClick() {
      if (this.video.paused || this.video.ended) {
        this.userPaused = false;
        const playRequest = this.video.play();

        if (playRequest?.catch) {
          playRequest.catch(() => this.syncState());
        }
      } else {
        this.userPaused = true;
        this.video.pause();
      }
    }

    handlePlay() {
      if (this.userPaused) {
        this.video.pause();
        return;
      }

      this.syncState();
    }

    handlePause() {
      this.syncState();
    }

    syncState() {
      const isPaused = this.video.paused || this.video.ended;
      this.button.dataset.state = isPaused ? 'paused' : 'playing';
      this.button.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
    }
  }

  customElements.define(elementName, GhFeaturedVideoControl);
})();
